"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commandClassMap = void 0;
const CommandType_1 = require("./CommandType");
const types_1 = require("../types");
exports.commandClassMap = {
    [CommandType_1.CommandType.NoteSequence]: types_1.NoteSequence,
    [CommandType_1.CommandType.Start]: types_1.StartCommand,
    [CommandType_1.CommandType.End]: types_1.EndCommand,
    [CommandType_1.CommandType.Measure]: types_1.MeasureCommand,
    [CommandType_1.CommandType.BPMChange]: types_1.BPMChangeCommand,
    [CommandType_1.CommandType.Delay]: types_1.DelayCommand,
    [CommandType_1.CommandType.Scroll]: types_1.ScrollCommand,
    [CommandType_1.CommandType.GoGoStart]: types_1.GoGoStartCommand,
    [CommandType_1.CommandType.GoGoEnd]: types_1.GoGoEndCommand,
    [CommandType_1.CommandType.BarLineOff]: types_1.BarLineOffCommand,
    [CommandType_1.CommandType.BarLineOn]: types_1.BarLineOnCommand,
    [CommandType_1.CommandType.BranchStart]: types_1.BranchStartCommand,
    [CommandType_1.CommandType.BranchEnd]: types_1.BranchEndCommand,
    [CommandType_1.CommandType.Section]: types_1.SectionCommand,
    [CommandType_1.CommandType.Lyric]: types_1.LyricCommand,
    [CommandType_1.CommandType.LevelHold]: types_1.LevelHoldCommand,
    [CommandType_1.CommandType.BMScroll]: types_1.BMScrollCommand,
    [CommandType_1.CommandType.HBScroll]: types_1.HBScrollCommand,
    [CommandType_1.CommandType.NextSong]: types_1.NextSongCommand,
    [CommandType_1.CommandType.Direction]: types_1.DirectionCommand,
    [CommandType_1.CommandType.Sudden]: types_1.SuddenCommand,
    'N': types_1.BranchMarkerCommand,
    'E': types_1.BranchMarkerCommand,
    'M': types_1.BranchMarkerCommand,
};
